import { storageType } from "../utils/environment";
import { DataStorage } from "./DataStorage";
import webViewStorageHandler from "./WebViewStorageHandler";
import idbKeyVal from "./idbKeyVal";

export const storage: DataStorage = storageType === "sqlite" ? webViewStorageHandler : idbKeyVal;
